import { Link } from "react-router-dom";
import { Logo } from "@/components/brand/Logo";
import { PostLoginAuthLink } from "@/components/routing/PostLoginAuthLink";

export function UnifiedFooter() {
  // Default: Clean white footer used across all pages
  return (
    <footer className="bg-white border-t py-8 md:py-12">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex flex-col items-center md:items-start gap-2">
            <Logo />
            <p className="text-sm text-gray-600 text-center md:text-left">
              Your comprehensive financial management solution
            </p>
          </div>

          <div className="grid grid-cols-2 sm:flex gap-8">
            <div className="flex flex-col space-y-2">
              <h3 className="font-medium text-sm">Product</h3>
              <PostLoginAuthLink
                mode="signup"
                signupType="company"
                className="text-sm text-gray-600 hover:text-primary"
              >
                For companies
              </PostLoginAuthLink>
              <Link to="/features" className="text-sm text-gray-600 hover:text-primary">
                Features
              </Link>
              <Link
                to="/family-wealth-management"
                className="text-sm text-gray-600 hover:text-primary"
              >
                Family wealth
              </Link>
              <Link to="/calculators" className="text-sm text-gray-600 hover:text-primary">
                Calculators
              </Link>
              <Link to="/pricing" className="text-sm text-gray-600 hover:text-primary">
                Pricing
              </Link>
              <Link to="/referrals" className="text-sm text-gray-600 hover:text-primary">
                Referrals
              </Link>
              <Link to="/blog" className="text-sm text-gray-600 hover:text-primary">
                Blog
              </Link>
              <Link to="/faq" className="text-sm text-gray-600 hover:text-primary">
                FAQ
              </Link>
              <a
                href="/sitemap.xml"
                className="text-sm text-gray-600 hover:text-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                Sitemap
              </a>
            </div>

            <div className="flex flex-col space-y-2">
              <h3 className="font-medium text-sm">Legal</h3>
              <Link to="/terms" className="text-sm text-gray-600 hover:text-primary">
                Terms of Service
              </Link>
              <Link to="/privacy" className="text-sm text-gray-600 hover:text-primary">
                Privacy Policy
              </Link>
              <Link to="/refunds" className="text-sm text-gray-600 hover:text-primary">
                Refunds & Cancellations
              </Link>
              <Link to="/products" className="text-sm text-gray-600 hover:text-primary">
                Products & Services
              </Link>
            </div>

            <div className="flex flex-col space-y-2">
              <h3 className="font-medium text-sm">Company</h3>
              <Link to="/about" className="text-sm text-gray-600 hover:text-primary">
                About Us
              </Link>
              <Link to="/contact-us" className="text-sm text-gray-600 hover:text-primary">
                Contact Us
              </Link>
            </div>
          </div>

          <p className="text-sm text-gray-600 mt-4 md:mt-0">
            © {new Date().getFullYear()} TellerWand. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
